import React, { useContext } from 'react';
import {
  ButtonVariant, ButtonSize, IconName, Tooltip,
} from '@usealloy/component-library';
import { StyledSwitchButton } from '../styles';
import { switchThresholdToDynamicComparison, switchThresholdToStaticComparison } from 'flow/store/redux/slice';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import { selectNodeFolderState } from 'flow/store/redux/selectors';
import { ThresholdContext } from './context';

const DynamicSwitchButton = () => {
  const dispatch = useAppDispatch();
  const inputAttributeNodeFolder = useAppSelector(selectNodeFolderState);

  const { isDynamic, populatedThreshold } = useContext(ThresholdContext);

  const onSwitchToDynamic = () => dispatch(
    switchThresholdToDynamicComparison({
      thresholdId: populatedThreshold.publicId,
      isNodeFolderCollapsed: inputAttributeNodeFolder,
    }),
  );

  const onSwitchToStatic = () => dispatch(
    switchThresholdToStaticComparison({
      thresholdId: populatedThreshold.publicId,
    }),
  );

  const tooltipContent = isDynamic ? 'Switch to static comparison' : 'Switch to dynamic comparison';

  return (
    <Tooltip
      align="start"
      content={tooltipContent}
      delayDuration={1000}
      side="top"
      variant="primary"
      hide={!tooltipContent}
    >
      <StyledSwitchButton
        variant={ButtonVariant.tertiary}
        size={ButtonSize.small}
        onClick={isDynamic ? onSwitchToStatic : onSwitchToDynamic}
        icon={IconName.Rerun}
        aria-label={tooltipContent}
      />
    </Tooltip>
  );
};

export default DynamicSwitchButton;
